import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { doMentionAgent } from 'actions/tickets'
import { doUpdateNoteDraftDelayed } from 'ducks/drafts'
import {
  doUpdateAgentMention,
  doUpdateSuppressMentionSelector,
} from 'actions/app'

import { selectAgentsById } from 'selectors/agents/base'
import { selectDeviceTypeIsDesktop } from 'selectors/app'
import {
  selectIsMentioningAgent,
  selectSelectedMentionSelectorAgentId,
  selectSuppressMentionSelector,
} from 'selectors/mentions'
import { selectIsReplyHeaderExpanded } from 'selectors/page'

import NoteForm from './view'

const select = state => {
  return {
    agentsById: selectAgentsById(state),
    isDesktop: selectDeviceTypeIsDesktop(state),
    isHeaderExpanded: selectIsReplyHeaderExpanded(state),
    isMentioning: selectIsMentioningAgent(state),
    selectedMentionSelectorAgentId: selectSelectedMentionSelectorAgentId(state),
    suppressMentionSelector: selectSuppressMentionSelector(state),
  }
}

const perform = dispatch => {
  return {
    ...bindActionCreators(
      {
        doMentionAgent,
        doUpdateAgentMention,
        doUpdateSuppressMentionSelector,
      },
      dispatch
    ),
    // Curry-able fns
    updateDraftDelayed: (ticketId, prop, val, opts) =>
      dispatch(doUpdateNoteDraftDelayed(ticketId, prop, val, opts)),
  }
}

export default connect(select, perform)(NoteForm)
